import { render, staticRenderFns } from "./TablaIndicadorComponent.vue?vue&type=template&id=ecba0402&scoped=true&"
import script from "./TablaIndicadorComponent.vue?vue&type=script&lang=js&"
export * from "./TablaIndicadorComponent.vue?vue&type=script&lang=js&"
import style0 from "./TablaIndicadorComponent.vue?vue&type=style&index=0&id=ecba0402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecba0402",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VDataTable,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet})
